import { render, staticRenderFns } from "./anayticsTaskGroup.vue?vue&type=template&id=23aa18ec&"
import script from "./anayticsTaskGroup.vue?vue&type=script&setup=true&lang=js&"
export * from "./anayticsTaskGroup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports